import { render } from "./CommandPersue.vue?vue&type=template&id=4bd752de&scoped=true&ts=true"
import script from "./CommandPersue.vue?vue&type=script&lang=ts"
export * from "./CommandPersue.vue?vue&type=script&lang=ts"

import "./CommandPersue.vue?vue&type=style&index=0&id=4bd752de&lang=scss"
import "./CommandPersue.vue?vue&type=style&index=1&id=4bd752de&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd752de"]])

export default __exports__